import { all, call, put, takeLatest } from 'redux-saga/effects';
import handleError from '@/adapters/httpErrors';
import bindingsProvider from '@/lib/bindings';
import { PageDTO } from '@/dtos/generics';
import BindingsDTO from '@/dtos/bindings/BindingsDTO';
import BindingsActions, { BindingsTypes } from './duck';
import { toast } from 'react-toastify';
import BindingGenealogyDTO from '@/dtos/bindings/BindingGenealogyDTO';

type ListParams = ReturnType<typeof BindingsActions.listRequest>;

export function* list({ payload }: ListParams): Generator {
  try {
    const { filters } = payload;
    const result = (yield call(
      bindingsProvider.listFiltered,
      filters
    )) as unknown as BindingsDTO[];

    const pageResult: PageDTO<BindingsDTO> = {
      data: result,
      total: result.length,
      prev: undefined,
      next: undefined,
      currentPage: 1,
    };

    yield put(BindingsActions.listSuccess(pageResult));
  } catch (err) {
    const error = handleError(err);
    yield put(BindingsActions.listError(error));
  }
}

type CreateParams = ReturnType<typeof BindingsActions.createRequest>;

export function* create({ payload }: CreateParams): Generator {
  try {
    const data = (yield call(bindingsProvider.create, payload)) as BindingsDTO;
    yield put(BindingsActions.createSuccess(data));
    toast.success('Vínculo criado com sucesso!');
    return data;
  } catch (err) {
    const error = handleError(err);
    yield put(BindingsActions.createError(error));
    return null;
  }
}

type LoadTraceParams = ReturnType<typeof BindingsActions.loadTraceRequest>;

export function* loadTrace({ payload }: LoadTraceParams): Generator {
  try {
    const { code } = payload;
    const result = (yield call(
      bindingsProvider.trace,
      code
    )) as unknown as BindingGenealogyDTO[];

    yield put(BindingsActions.loadTraceSuccess(result));
  } catch (err) {
    toast.error('Falha ao buscar a genealogia de vínculos.');
    handleError(err);
    yield put(BindingsActions.loadTraceFailure());
  }
}

export default all([
  takeLatest(BindingsTypes.LIST_REQUEST, list),
  takeLatest(BindingsTypes.CREATE_REQUEST, create),
  takeLatest(BindingsTypes.LOAD_TRACE_REQUEST, loadTrace),
]);
